import { render } from "./EditInfoForm.vue?vue&type=template&id=a2296f0c&scoped=true"
import script from "./EditInfoForm.vue?vue&type=script&lang=js"
export * from "./EditInfoForm.vue?vue&type=script&lang=js"

import "./EditInfoForm.vue?vue&type=style&index=0&id=a2296f0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2296f0c"]])

export default __exports__